import React, { useEffect, useState } from "react";
import { Input } from "@t8891/mobile";
import { ISuperFrom } from "./SuperForm";
import { InquirySecondInformation } from "@legacy/types/bidding";
import { getValueByItemId } from "utils/InquiryLogistics";

interface ISelectRadio extends ISuperFrom {
  item: any;
  parentItemId: number;
}

const InputText: React.FC<ISelectRadio> = ({ item, parentItemId, formParams, onChange }) => {
  const [defaultValue, setDefaultValue] = useState(undefined);
  const { placeholder, itemId, required, title } = item;

  useEffect(() => {
    let labelAndValue = getValueByItemId({ formParams, itemId, item });

    if (!!labelAndValue.value) {
      setDefaultValue(labelAndValue.value);
    }
  }, []);
  let isChiildren = parentItemId === item.itemId;

  return (
    <>
      <div className={`${isChiildren ? "grid" : "flex"}  gap-12 items-center`}>
        <div className={`${isChiildren ? "text-16 font-[600]" : "text-14  h-40"} flex whitespace-pre items-center`}>
          {!!required && (
            <div className='flex items-center'>
              <div className='text-[#FF0000] text-16 h-10'>*</div>
            </div>
          )}
          {title}
        </div>
        <div className='relative font-[400]'>
          <div
            className={`flex-wrap  rounded-4  ${
              isChiildren ? "w-[446px]" : "w-[290px]"
            } inline-flex gap-4 min-h-40 relative cursor-pointer`}
          >
            <Input
              style={{ "--input-font-size": "14px", height: "40px", padding: "0 10px", borderColor: "#E8E8E8" }}
              placeholder={placeholder}
              border={true}
              defaultValue={defaultValue}
              // value={tipsValue}
              onChange={(val) => {
                item.parentItemId = parentItemId;
                item.value = val;
                onChange(item);
              }}
              // tips={!!tipsValue ? "禁止输入内容" : ""}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default InputText;
